import apiTool from './index';
export default {
  addAllClientBrands(payload) {
    // The route is 'clients/client_id/all_marques/'
    console.log('DEBUG | brand.js | addAllClientBrands');
    console.log('this is the payload that was sent');
    console.log(payload);

    const route = 'clients/' + payload.client_id + '/all_marques/';

    return apiTool.post(route, payload.data);
  },

  getBrands(payload) {
    // The route is 'marques/?no_page&limit=25&search='str'
    const route = 'marques/?no_page&limit=25&search=' + payload.search;

    return apiTool.get(route);
  },
  getAllClientBrands(payload) {
    // The route is 'clients/client_id/all_marques/?no_page'
    const route = 'clients/' + payload.client_id + '/all_marques/?no_page';

    return apiTool.get(route);
  },
  getClientBrandWithWines(payload) {
    // The route is 'clients/client_id/client_marques/?no_page'
    const route = 'clients/' + payload.client_id + '/client_marques/?no_page';

    return apiTool.get(route);
  },
  getRivalBrandWithWines(payload) {
    // The route is 'clients/client_id/rival_marques/?no_page'
    const route = 'clients/' + payload.client_id + '/rival_marques/?no_page';

    return apiTool.get(route);
  },

  updateClientBrand(payload) {
    // The route is 'clients/client_id/clients_marques/marque_id/'
    console.log('DEBUG | brand.js | updateClientBrand');
    console.log('this is the payload that was sent');
    console.log(payload);

    const route =
      'clients/' +
      payload.client_id +
      '/client_marques/' +
      payload.marque_id +
      '/';

    return apiTool.put(route, payload.data);
  },
  updateRivalBrand(payload) {
    //  The route is 'clients/client_id/rival_marques/marque_id/'
    console.log('DEBUG | brand.js | updateRivalBrand');
    console.log('this is the payload that was sent');
    console.log(payload);

    const route =
      'clients/' +
      payload.client_id +
      '/rival_marques/' +
      payload.marque_id +
      '/';

    return apiTool.put(route, payload.data);
  }
};
